document.documentElement.classList.add('js');

const menuToggle = document.querySelector('[data-menu-toggle]');
const menuPanel = document.querySelector('[data-menu-panel]');

if (menuToggle && menuPanel) {
  const megaMenus = [...menuPanel.querySelectorAll('[data-mega-menu]')];
  const closeMenu = () => {
    menuToggle.setAttribute('aria-expanded', 'false');
    menuPanel.classList.remove('is-open');
    megaMenus.forEach((menu) => menu.removeAttribute('open'));
    menuToggle.focus();
  };

  menuToggle.addEventListener('click', () => {
    const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
    menuToggle.setAttribute('aria-expanded', String(!isOpen));
    menuPanel.classList.toggle('is-open', !isOpen);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && menuToggle.getAttribute('aria-expanded') === 'true') {
      closeMenu();
    }
  });

  menuPanel.addEventListener('click', (event) => {
    if (event.target.closest('a') && window.matchMedia('(max-width: 820px)').matches) closeMenu();
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-mega-menu]')) megaMenus.forEach((menu) => menu.removeAttribute('open'));
  });
}

document.querySelectorAll('.product-gallery').forEach((gallery) => {
  const galleryMain = gallery.querySelector('[data-gallery-main]');
  const galleryButtons = gallery.querySelectorAll('[data-gallery-thumb]');

  if (!galleryMain || galleryButtons.length === 0) return;

  galleryButtons.forEach((button) => {
    button.addEventListener('click', () => {
      galleryMain.src = button.dataset.src;
      galleryMain.srcset = button.dataset.srcset;
      galleryMain.alt = button.dataset.alt;
      galleryMain.width = Number(button.dataset.width);
      galleryMain.height = Number(button.dataset.height);
      galleryButtons.forEach((item) => item.setAttribute('aria-current', 'false'));
      button.setAttribute('aria-current', 'true');
    });
  });
});

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const reveals = document.querySelectorAll('.reveal');

if (!reduceMotion && 'IntersectionObserver' in window) {
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 },
  );
  reveals.forEach((item) => observer.observe(item));
} else {
  reveals.forEach((item) => item.classList.add('is-visible'));
}

/* Les préférences de cookies, rouvertes depuis le pied de page.
 *
 * Shopify range ce rappel parmi les politiques, avec une adresse dont le
 * chemin n'existe pas: « /policies/#shopifyReshowConsentBanner ». C'était une
 * erreur 4xx sur chacune des pages du site. Sa documentation ne connaît qu'une
 * voie pour rouvrir la bannière, et c'est celle-ci.
 */
document.addEventListener('click', (evenement) => {
  if (!evenement.target.closest('[data-preferences-cookies]')) return;
  evenement.preventDefault();
  window.privacyBanner?.showPreferences?.();
});

let activeCartController = null;
let activeProductPurchaseController = null;
let nativeCartActionConfigured = false;

/* Le compte d'articles, dans l'en-tête.
 *
 * Trois surfaces changent le panier sans recharger la page: le panier, la
 * fiche produit, et le panneau. L'en-tête, lui, n'est rendu qu'au chargement.
 * Chacune l'écrivait pour son compte; à la troisième, la même dizaine de
 * lignes en trois exemplaires devenait trois occasions de diverger.
 */
function majCompteEnTete(quantiteTotale, adressePanier) {
  const lien = document.querySelector(`.header__icons a[href="${adressePanier}"]`);
  if (!lien) return;

  let compte = lien.querySelector('sup');
  if (quantiteTotale > 0 && !compte) {
    compte = document.createElement('sup');
    lien.prepend(compte);
  }

  if (compte) {
    compte.textContent = String(quantiteTotale);
    compte.hidden = quantiteTotale === 0;
  }
  lien.setAttribute('aria-label', `Panier : ${quantiteTotale} article(s)`);
}

/* La jauge de port offert, rejouée après un ajout depuis la fiche produit.
 *
 * Le serveur la rend au chargement, et le panier renvoie toute sa section à
 * chaque changement de quantité: c'est donc la seule surface qui aurait
 * vieilli, la fiche produit ne rechargeant rien quand on ajoute au panier.
 *
 * Le seuil vient de l'attribut posé par le snippet, en centimes, et n'est donc
 * écrit qu'une fois, dans le snippet des frais de livraison.
 *
 * Le total arrive en euros décimaux, tel que le renvoie l'action de Shopify.
 */
const monnaieDuDomaine = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
});

function rafraichirJaugePort(totalEnEuros) {
  const total = Number(totalEnEuros);
  if (!Number.isFinite(total)) return;

  document.querySelectorAll('[data-jauge-port]').forEach((jauge) => {
    const seuil = Number(jauge.dataset.seuil) / 100;
    if (!Number.isFinite(seuil) || seuil <= 0) return;

    const offert = total >= seuil;
    jauge.hidden = total <= 0;
    jauge.classList.toggle('shipping-gauge--offerte', offert);

    const mot = jauge.querySelector('[data-jauge-mot]');
    if (mot) {
      mot.textContent = offert
        ? 'Livraison offerte.'
        : `Plus que ${monnaieDuDomaine.format(seuil - total)} pour la livraison offerte.`;
    }

    const part = jauge.querySelector('[data-jauge-part]');
    if (part) {
      part.style.width = `${offert ? 100 : Math.round((total / seuil) * 100)}%`;
    }
  });
}

class ShopifyCartController {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('[data-cart-form]');
    this.status = root.querySelector('[data-cart-status]');
    this.sectionId = root.dataset.sectionId;
    this.cartUrl = root.dataset.cartUrl;
    this.pendingChanges = new Map();
    this.debounceTimer = null;
    this.abortController = null;
    this.isUpdating = false;
    this.focusTarget = null;

    this.handleClick = this.handleClick.bind(this);
    this.handleInput = this.handleInput.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeydown = this.handleKeydown.bind(this);
  }

  init() {
    const updateCart = window.Shopify?.actions?.updateCart;
    activeCartController = this;
    if (!this.form || typeof updateCart !== 'function' || typeof updateCart.configure !== 'function') {
      return false;
    }

    if (!this.configureNativeAction(updateCart)) return false;

    this.root.classList.add('is-enhanced');
    this.form.addEventListener('click', this.handleClick);
    this.form.addEventListener('input', this.handleInput);
    this.form.addEventListener('change', this.handleChange);
    this.form.addEventListener('keydown', this.handleKeydown);
    return true;
  }

  configureNativeAction(updateCart) {
    if (nativeCartActionConfigured) return true;

    try {
      updateCart.configure({
        eventTarget: () => activeCartController?.root || document,
        async handler(defaultHandler) {
          const controller = activeCartController;
          const result = await defaultHandler();
          await controller.refreshSection();
          return result;
        },
      });
    } catch {
      return false;
    }

    nativeCartActionConfigured = true;
    return true;
  }

  handleClick(event) {
    const button = event.target.closest('[data-cart-adjust]');
    if (!button || !this.form.contains(button)) return;

    const line = button.closest('[data-cart-line]');
    const input = line?.querySelector('[data-cart-quantity]');
    if (!input) return;

    const delta = Number(button.dataset.cartAdjust);
    const current = this.normalizeQuantity(input.value);
    input.value = String(Math.max(0, current + delta));
    this.scheduleChange(input, 150, button.dataset.cartAdjust === '-1' ? 'decrement' : 'increment');
  }

  handleInput(event) {
    if (!event.target.matches('[data-cart-quantity]')) return;
    this.scheduleChange(event.target, 400, 'input');
  }

  handleChange(event) {
    if (!event.target.matches('[data-cart-quantity]')) return;
    if (event.target.value.trim() === '') {
      event.target.value = event.target.dataset.currentQuantity;
      return;
    }
    this.scheduleChange(event.target, 0, 'input');
  }

  handleKeydown(event) {
    if (event.key !== 'Enter' || !event.target.matches('[data-cart-quantity]')) return;
    event.preventDefault();
    this.scheduleChange(event.target, 0, 'input');
  }

  normalizeQuantity(value) {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? Math.max(0, parsed) : 0;
  }

  scheduleChange(input, delay, control) {
    const key = input.dataset.lineKey;
    if (!key || input.value.trim() === '' || !input.validity.valid) return;

    const quantity = this.normalizeQuantity(input.value);
    input.value = String(quantity);
    this.pendingChanges.set(key, quantity);
    this.focusTarget = { key, control };
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(() => this.flushChanges(), delay);
  }

  async flushChanges() {
    if (this.isUpdating || this.pendingChanges.size === 0) return;

    const lines = Array.from(this.pendingChanges, ([id, quantity]) => ({ id, quantity }));
    this.pendingChanges.clear();
    this.isUpdating = true;
    this.abortController = new AbortController();
    this.setBusy(true);
    this.showStatus('Mise à jour du panier…');

    try {
      const result = await window.Shopify.actions.updateCart(
        { lines },
        {
          signal: this.abortController.signal,
          event: { context: 'cart', detail: { source: 'font-des-ormes-cart' } },
        },
      );

      const controller = activeCartController || this;
      controller.updateHeaderCount(result.cart?.totalQuantity || 0);

      if (result.userErrors?.length) {
        controller.showStatus(result.userErrors[0].message, true);
      } else if (result.warnings?.length) {
        controller.showStatus(result.warnings[0].message);
      } else {
        controller.showStatus('Panier mis à jour.');
      }

      controller.restoreFocus(this.focusTarget);
    } catch (error) {
      if (error.name !== 'AbortError') {
        const controller = activeCartController || this;
        controller.restoreConfirmedQuantities();
        controller.showStatus('Le panier n’a pas pu être mis à jour. Réessayez.', true);
      }
    } finally {
      const controller = activeCartController || this;
      controller.setBusy(false);
      this.isUpdating = false;
    }
  }

  async refreshSection() {
    const url = new URL(this.cartUrl, window.location.origin);
    url.searchParams.set('section_id', this.sectionId);

    try {
      const response = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error(`Cart section ${response.status}`);

      const markup = await response.text();
      const parsed = new DOMParser().parseFromString(markup, 'text/html');
      const nextRoot = parsed.querySelector('[data-cart-section]');
      if (!nextRoot) throw new Error('Cart section missing');

      this.root.replaceWith(nextRoot);
      initializeDynamicCart(nextRoot);
    } catch (error) {
      window.location.assign(this.cartUrl);
      throw error;
    }
  }

  setBusy(isBusy) {
    this.root.setAttribute('aria-busy', String(isBusy));
    this.root.classList.toggle('is-updating', isBusy);
    this.form
      ?.querySelectorAll('[data-cart-adjust], [data-cart-quantity], [name="checkout"]')
      .forEach((control) => {
        control.disabled = isBusy;
      });
  }

  showStatus(message, isError = false) {
    if (!this.status) return;
    this.status.hidden = false;
    this.status.textContent = message;
    this.status.classList.toggle('is-error', isError);
  }

  restoreConfirmedQuantities() {
    this.root.querySelectorAll('[data-cart-quantity]').forEach((input) => {
      input.value = input.dataset.currentQuantity;
    });
  }

  updateHeaderCount(totalQuantity) {
    majCompteEnTete(totalQuantity, this.cartUrl);
  }

  restoreFocus(target) {
    if (!target) return;
    const line = this.root.querySelector(
      `[data-cart-line][data-line-key="${CSS.escape(target.key)}"]`,
    );
    const selector =
      target.control === 'increment'
        ? '[data-cart-adjust="1"]'
        : target.control === 'decrement'
          ? '[data-cart-adjust="-1"]'
          : '[data-cart-quantity]';
    const control = line?.querySelector(selector);
    (control || this.root.querySelector('[data-cart-summary], .utility-empty-state a'))?.focus();
  }
}

function initializeDynamicCart(root = document.querySelector('[data-cart-section]')) {
  if (!root) return;
  const controller = new ShopifyCartController(root);
  controller.init();
}

/* Le panneau du panier, ouvert après un ajout.
 *
 * Son contenu vient du serveur: on redemande la section à Shopify et on
 * remplace l'en-tête et le corps. Les montants, les remises et la jauge
 * sortent donc du même Liquid que la page du panier, et rien n'est recomposé
 * en JavaScript, pas même après un changement de quantité.
 *
 * La minuterie de fermeture est une commodité, pas une règle: elle tombe dès
 * qu'on s'occupe du panneau. Un panneau qui disparaît pendant qu'on le lit est
 * pire qu'un panneau qui reste.
 */
const MiniPanier = {
  delaiFermeture: 6000,
  minuterie: null,
  declencheur: null,
  occupe: false,
  // Les changements de quantité en attente d'envoi, une entrée par ligne: le
  // dernier nombre voulu écrase le précédent, et l'échange n'a lieu qu'une fois.
  enAttente: new Map(),
  report: null,
  dernierGeste: null,

  racine() {
    return document.querySelector('[data-mini-panier]');
  },

  adressePanier() {
    return this.racine()?.dataset.cartUrl || '/cart';
  },

  /* L'identifiant que l'interface de rendu de section attend. Il est lu dans
   * le DOM plutôt qu'écrit ici: le groupe d'en-tête le compose lui-même, et
   * une copie en dur se démoderait au premier renommage. */
  identifiantSection() {
    const enveloppe = this.racine()?.closest('.shopify-section');
    return enveloppe ? enveloppe.id.replace(/^shopify-section-/, '') : null;
  },

  /* Le panneau redemandé au serveur, en l'état où le panier est vraiment.
   *
   * Deux morceaux sont remplacés et un troisième ne l'est jamais: le statut,
   * entre les deux, est une région vivante, et une région recréée à chaque
   * échange n'est plus annoncée par les lecteurs d'écran.
   *
   * Le défilement de la liste est repris tel quel: sans cela, changer la
   * quantité de la septième ligne renvoyait la liste tout en haut. */
  async rafraichir() {
    const racine = this.racine();
    const id = this.identifiantSection();
    if (!racine || !id) return false;

    const hauteur = racine.querySelector('.mini-panier__lignes')?.scrollTop || 0;
    const reponse = await fetch(
      `${window.location.pathname}?section_id=${encodeURIComponent(id)}`,
      { headers: { Accept: 'text/html' } },
    );
    if (!reponse.ok) return false;

    const html = new DOMParser().parseFromString(await reponse.text(), 'text/html');
    let pose = false;
    ['[data-mini-panier-tete]', '[data-mini-panier-contenu]'].forEach((quoi) => {
      const frais = html.querySelector(`[data-mini-panier] ${quoi}`);
      const ancien = racine.querySelector(quoi);
      if (!frais || !ancien) return;
      ancien.replaceWith(frais);
      pose = true;
    });

    const liste = racine.querySelector('.mini-panier__lignes');
    if (liste) liste.scrollTop = hauteur;
    return pose;
  },

  /* Ce qu'a répondu Shopify. La confirmation reste hors champ: l'écran montre
   * déjà le nouveau nombre, et une phrase de plus à chaque clic ferait du bruit
   * dans un panneau de quatre cents pixels. Un avertissement de stock ou une
   * erreur s'affichent, eux: un bouton qui ne bouge pas sans un mot passe pour
   * cassé. */
  dire(message, ton = 'confirmation') {
    const zone = this.racine()?.querySelector('[data-mini-panier-statut]');
    if (!zone) return;
    zone.textContent = message || '';
    zone.hidden = !message;
    zone.classList.toggle('is-error', ton === 'erreur');
    zone.toggleAttribute('data-hors-champ', ton === 'confirmation');
  },

  /* Un clic sur « − », « + » ou « Supprimer ».
   *
   * Chaque bouton porte la quantité qu'il vise, écrite par le serveur. Le
   * panneau la montre aussitôt, puis attend un instant avant de parler à
   * Shopify: trois clics sur « + » font trois pas à l'écran et un seul échange,
   * là où un envoi par clic aurait renvoyé le premier rendu au milieu du
   * deuxième clic. */
  changer(bouton) {
    const ligne = bouton.closest('[data-mini-ligne]');
    const cle = ligne?.dataset.miniCle;
    const quantite = Number(bouton.dataset.miniQuantite);
    if (!cle || !Number.isFinite(quantite)) return;

    this.desarmer();
    this.dire('');
    this.projeter(ligne, quantite);
    this.dernierGeste = { cle, sens: bouton.dataset.miniSens };
    this.enAttente.set(cle, quantite);
    clearTimeout(this.report);
    this.report = setTimeout(() => this.poster(), 300);
  },

  /* L'écran suit le doigt, en attendant que le serveur tranche.
   *
   * C'est la seule arithmétique du panneau, et elle ne survit pas à l'échange:
   * le rendu suivant réécrit la ligne, plafond de stock compris. Les montants,
   * eux, ne sont jamais recomposés ici. */
  projeter(ligne, quantite) {
    if (!ligne) return;
    if (quantite <= 0) {
      ligne.hidden = true;
      return;
    }
    const valeur = ligne.querySelector('.mini-panier__quantite span');
    if (valeur) valeur.textContent = String(quantite);

    const moins = ligne.querySelector('[data-mini-sens="moins"]');
    if (moins) {
      moins.dataset.miniQuantite = String(quantite - 1);
      moins.disabled = quantite <= 1;
    }
    const plus = ligne.querySelector('[data-mini-sens="plus"]');
    if (plus) plus.dataset.miniQuantite = String(quantite + 1);
  },

  async poster() {
    const majPanier = window.Shopify?.actions?.updateCart;
    if (this.occupe || this.enAttente.size === 0 || typeof majPanier !== 'function') return;

    const lignes = Array.from(this.enAttente, ([id, quantity]) => ({ id, quantity }));
    this.enAttente.clear();
    this.occupe = true;
    this.racine()?.classList.add('is-updating');

    try {
      const resultat = await majPanier(
        { lines: lignes },
        { event: { context: 'cart', detail: { source: 'font-des-ormes-mini-panier' } } },
      );

      if (resultat.userErrors?.length) {
        this.dire(resultat.userErrors[0].message, 'erreur');
      } else if (resultat.warnings?.length) {
        // Demander six bouteilles quand il en reste quatre: Shopify plafonne et
        // le dit. Sans cette ligne, « + » paraîtrait simplement cassé.
        this.dire(resultat.warnings[0].message, 'note');
      } else {
        this.dire(this.resume(lignes));
      }

      majCompteEnTete(resultat.cart?.totalQuantity || 0, this.adressePanier());
      rafraichirJaugePort(resultat.cart?.cost?.totalAmount?.amount);
    } catch (erreur) {
      if (erreur.name !== 'AbortError') {
        this.dire('Le panier n’a pas pu être mis à jour. Réessayez.', 'erreur');
      }
    }

    this.occupe = false;
    this.racine()?.classList.remove('is-updating');

    // Quoi qu'ait répondu Shopify, l'affichage repart de ce qu'il rend: une
    // projection démentie, par un refus comme par un plafond de stock, ne
    // survit pas à l'échange.
    try {
      await this.rafraichir();
    } catch {
      /* Le panneau garde ce qu'il montre, et « Voir le panier » reste juste. */
    }
    this.rendreLeFocus(this.dernierGeste);

    // Un clic tombé pendant l'échange repart aussitôt.
    if (this.enAttente.size > 0) this.poster();
  },

  resume(lignes) {
    if (lignes.length !== 1) return 'Panier mis à jour.';
    const [seule] = lignes;
    return seule.quantity === 0 ? 'Ligne supprimée.' : `Quantité : ${seule.quantity}.`;
  },

  /* Le bouton cliqué n'existe plus, le corps du panneau ayant été remplacé. On
   * reprend son homologue sur la même ligne, reconnu par son sens et non par sa
   * valeur, qui vient de changer. La ligne supprimée, ou « − » qui s'éteint au
   * premier exemplaire, renvoient au premier contrôle du panneau. */
  rendreLeFocus(geste) {
    const racine = this.racine();
    // Le panneau a pu être refermé pendant l'échange: le focus est alors
    // retourné au bouton d'ajout, et le lui reprendre serait le perdre. La
    // classe tombe dès le clic, l'attribut seulement à la fin du glissement.
    if (!racine || racine.hidden || !racine.classList.contains('is-open')) return;
    if (!geste?.cle) return;

    const ligne = racine.querySelector(
      `[data-mini-ligne][data-mini-cle="${CSS.escape(geste.cle)}"]`,
    );
    const vise = geste.sens ? ligne?.querySelector(`[data-mini-sens="${geste.sens}"]`) : null;
    if (vise && !vise.disabled) {
      vise.focus();
      return;
    }

    const repli = ligne?.querySelector('[data-mini-sens="plus"]')
      || racine.querySelector('[data-mini-panier-contenu] a, [data-mini-panier-contenu] button')
      || racine.querySelector('[data-mini-panier-cadre]');
    repli?.focus({ preventScroll: true });
  },

  async ouvrir(declencheur) {
    const racine = this.racine();
    if (!racine) return;

    this.dire('');
    try {
      await this.rafraichir();
    } catch {
      /* Le panneau garde alors le contenu du chargement de page. Il est
       * peut-être en retard d'une ligne, et c'est moins grave que de ne rien
       * ouvrir du tout: « Voir le panier » reste juste. */
    }

    this.declencheur = declencheur || null;
    racine.hidden = false;
    racine.setAttribute('aria-hidden', 'false');
    // Lire une mesure force le calcul de la mise en page: la transition part
    // alors de l'état d'avant la classe. C'était `requestAnimationFrame`, qui
    // ne tourne pas quand l'onglet passe à l'arrière-plan: le panneau restait
    // hors champ, ouvert mais invisible.
    void racine.offsetWidth;
    racine.classList.add('is-open');
    racine.querySelector('[data-mini-panier-cadre]')?.focus({ preventScroll: true });
    this.brancher(racine);
    this.armer();
  },

  fermer() {
    const racine = this.racine();
    if (!racine || racine.hidden) return;
    clearTimeout(this.minuterie);

    // Un changement encore en attente part maintenant. Refermer trois cents
    // millisecondes après un clic sur « + » ne doit pas perdre la bouteille,
    // et le compte de l'en-tête le dira.
    if (this.enAttente.size > 0) {
      clearTimeout(this.report);
      this.poster();
    }

    racine.classList.remove('is-open');
    racine.setAttribute('aria-hidden', 'true');

    const finir = () => {
      racine.hidden = true;
      // Le focus revient d'où il est parti: sans cela, le clavier repart du
      // haut du document après chaque ajout.
      this.declencheur?.focus?.({ preventScroll: true });
      this.declencheur = null;
    };
    const cadre = racine.querySelector('[data-mini-panier-cadre]');
    if (!cadre || matchMedia('(prefers-reduced-motion: reduce)').matches) return finir();
    cadre.addEventListener('transitionend', finir, { once: true });
    setTimeout(finir, 400);
  },

  armer() {
    clearTimeout(this.minuterie);
    this.minuterie = setTimeout(() => this.fermer(), this.delaiFermeture);
  },

  desarmer() {
    clearTimeout(this.minuterie);
    this.minuterie = null;
  },

  brancher(racine) {
    if (racine.dataset.branche === 'oui') return;
    racine.dataset.branche = 'oui';

    // La délégation tient sur la racine, qui n'est jamais remplacée: les
    // boutons de quantité renaissent à chaque échange avec le serveur, et un
    // écouteur posé sur chacun d'eux serait perdu au premier rafraîchissement.
    racine.addEventListener('click', (evenement) => {
      if (evenement.target.closest('[data-mini-panier-fermer], [data-mini-panier-voile]')) {
        this.fermer();
        return;
      }
      this.desarmer();
      const bouton = evenement.target.closest('[data-mini-quantite]');
      if (bouton) this.changer(bouton);
    });
    // S'occuper du panneau annule la fermeture automatique: le survol, la
    // molette, une touche frappée dedans.
    //
    // Pas `focusin`: c'est l'ouverture elle-même qui donne le focus au cadre,
    // donc le signal serait toujours vrai et la minuterie ne tomberait jamais.
    // Un visiteur au clavier qui tabule dans le panneau frappe une touche, et
    // c'est `keydown` qui l'entend.
    ['pointerenter', 'wheel', 'keydown'].forEach((nom) => {
      racine.addEventListener(nom, () => this.desarmer(), { passive: true });
    });
    document.addEventListener('keydown', (evenement) => {
      if (evenement.key === 'Escape') this.fermer();
    });
  },
};

class ShopifyProductPurchaseController {
  constructor(root) {
    this.root = root;
    this.form = root.querySelector('form');
    this.quantity = root.querySelector('[data-product-quantity]');
    this.submit = root.querySelector('[data-product-submit]');
    this.status = root.querySelector('[data-product-purchase-status]');
    this.cartLink = root.querySelector('[data-product-cart-link]');
    this.cartUrl = root.dataset.cartUrl;
    this.addingLabel = root.dataset.addingLabel;
    this.addedLabel = root.dataset.addedLabel;
    this.errorLabel = root.dataset.errorLabel;
    this.isUpdating = false;

    this.handleClick = this.handleClick.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  init() {
    const updateCart = window.Shopify?.actions?.updateCart;
    if (
      !this.form ||
      !this.quantity ||
      !this.submit ||
      typeof updateCart !== 'function' ||
      typeof updateCart.configure !== 'function'
    ) {
      return false;
    }

    activeProductPurchaseController = this;
    if (!nativeCartActionConfigured) {
      try {
        updateCart.configure({
          eventTarget: () => activeProductPurchaseController?.root || document,
          async handler(defaultHandler) {
            return defaultHandler();
          },
        });
      } catch {
        return false;
      }
      nativeCartActionConfigured = true;
    }

    this.root.classList.add('is-enhanced');
    this.form.addEventListener('click', this.handleClick);
    this.form.addEventListener('submit', this.handleSubmit);
    return true;
  }

  handleClick(event) {
    const button = event.target.closest('[data-product-quantity-adjust]');
    if (!button || !this.form.contains(button)) return;

    const current = this.normalizeQuantity(this.quantity.value);
    const delta = Number(button.dataset.productQuantityAdjust);
    const maximum = this.quantity.max ? Number(this.quantity.max) : Number.POSITIVE_INFINITY;
    this.quantity.value = String(Math.min(maximum, Math.max(1, current + delta)));
  }

  async handleSubmit(event) {
    if (event.submitter && !event.submitter.matches('[data-product-submit]')) return;
    if (this.isUpdating || !this.form.reportValidity()) return;

    const formData = new FormData(this.form);
    const merchandiseId = String(formData.get('id') || '');
    const quantity = this.normalizeQuantity(formData.get('quantity'));
    if (!merchandiseId || quantity < 1) return;

    event.preventDefault();
    activeProductPurchaseController = this;
    this.setBusy(true);
    this.showStatus(this.addingLabel || 'Ajout au panier…');

    try {
      const result = await window.Shopify.actions.updateCart(
        { lines: [{ merchandiseId, quantity }] },
        {
          event: { context: 'product', detail: { source: 'font-des-ormes-product' } },
        },
      );

      if (result.userErrors?.length) {
        this.showStatus(result.userErrors[0].message, true);
        return;
      }

      this.updateHeaderCount(result.cart?.totalQuantity || 0);
      rafraichirJaugePort(result.cart?.cost?.totalAmount?.amount);
      if (result.warnings?.length) {
        this.showStatus(result.warnings[0].message);
      } else {
        this.showStatus(this.addedLabel || `Ajouté au panier : ${quantity} ${quantity > 1 ? 'unités' : 'unité'}.`);
      }
      if (this.cartLink) this.cartLink.hidden = false;
      // Le panneau montre le panier sans quitter la fiche. La phrase ci-dessus
      // reste: elle est ce qu'annoncent les lecteurs d'écran, et le panneau
      // n'a pas de région vivante pour ne pas le dire deux fois.
      MiniPanier.ouvrir(this.submit);
    } catch (error) {
      if (error.name !== 'AbortError') {
        this.showStatus(this.errorLabel || 'Le produit n’a pas pu être ajouté. Réessayez.', true);
      }
    } finally {
      this.setBusy(false);
    }
  }

  normalizeQuantity(value) {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? Math.max(1, parsed) : 1;
  }

  setBusy(isBusy) {
    this.isUpdating = isBusy;
    this.root.classList.toggle('is-updating', isBusy);
    this.root.setAttribute('aria-busy', String(isBusy));
    this.form
      .querySelectorAll('[data-product-quantity-adjust], [data-product-quantity], [data-product-submit]')
      .forEach((control) => {
        control.disabled = isBusy;
      });
  }

  showStatus(message, isError = false) {
    if (!this.status) return;
    this.status.hidden = false;
    this.status.textContent = message;
    this.status.classList.toggle('is-error', isError);
  }

  updateHeaderCount(totalQuantity) {
    majCompteEnTete(totalQuantity, this.cartUrl);
  }
}

function initializeDynamicProductPurchase() {
  document.querySelectorAll('[data-product-purchase]').forEach((root) => {
    const controller = new ShopifyProductPurchaseController(root);
    controller.init();
  });
}

function initializeCommerce() {
  initializeDynamicCart();
  initializeDynamicProductPurchase();
}

window.FDOTheme = window.FDOTheme || {};
window.FDOTheme.initializeCommerce = initializeCommerce;

/* Le choix de couleur ne recharge pas la collection et ne crée aucune URL
 * filtrée. Tout reste dans le HTML pour la navigation sans JavaScript et pour
 * les moteurs ; on ne fait que réduire ce qui occupe l'écran. */
document.querySelectorAll('[data-fdo-wine-catalogue]').forEach((catalogue) => {
  const buttons = [...catalogue.querySelectorAll('[data-fdo-wine-filter]')];
  const groups = [...catalogue.querySelectorAll('[data-fdo-wine-colour]')];
  const context = catalogue.querySelector('[data-fdo-filter-context]');
  const contextLabel = catalogue.querySelector('[data-fdo-filter-context-label]');
  const contextHelp = catalogue.querySelector('[data-fdo-filter-context-help]');
  const recommendedHeading = catalogue.querySelector('[data-fdo-recommended-heading]');
  const otherHeading = catalogue.querySelector('[data-fdo-other-products-label]');
  const emptyMessage = catalogue.querySelector('[data-fdo-filter-empty]');
  const params = new URLSearchParams(window.location.search);
  const requestedColour = params.get('couleur');
  const requestedPairing = params.get('accord');
  const requestedAvailability = params.get('disponibilite');
  const isComingContext = requestedAvailability === 'prochainement';
  const contextActive = Boolean(requestedPairing || isComingContext);
  catalogue.dataset.contextActive = String(contextActive);

  const normalize = (value) =>
    value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-');

  const applyFilters = (colour = 'all') => {
    let visibleCards = 0;
    let contextMatchCount = 0;

    groups.forEach((group) => {
      const colourMatches = colour === 'all' || group.dataset.fdoWineColour === colour;

      group.querySelectorAll('.fdo-wine-family').forEach((card) => {
        const pairingMatches = !requestedPairing || (card.dataset.pairings || '').includes(normalize(requestedPairing));
        const availabilityMatches = requestedAvailability !== 'prochainement' || card.dataset.hasComing === 'true';
        const contextMatches = pairingMatches && availabilityMatches;
        const visible = colourMatches;
        const matchBadge = card.querySelector('[data-fdo-selection-match]');
        const matchReasons = card.querySelectorAll('[data-fdo-selection-reason]');
        card.hidden = !visible;
        card.dataset.contextMatch = String(Boolean(contextActive && contextMatches));
        if (matchBadge) {
          matchBadge.hidden = card.dataset.contextMatch !== 'true';
          matchBadge.textContent = isComingContext
            ? catalogue.dataset.comingLabel
            : catalogue.dataset.selectionMatchLabel;
        }
        matchReasons.forEach((reason) => {
          reason.hidden = !requestedPairing || isComingContext || card.dataset.contextMatch !== 'true';
        });
        if (visible) {
          visibleCards += 1;
          if (contextActive && contextMatches) contextMatchCount += 1;
          if (requestedAvailability === 'prochainement' && contextMatches) card.querySelector('details')?.setAttribute('open', '');
        }
      });

      group.hidden = !colourMatches;
    });

    if (emptyMessage) emptyMessage.hidden = contextActive ? contextMatchCount > 0 : visibleCards > 0;
    catalogue.dataset.hasContextMatches = String(contextActive && contextMatchCount > 0);
  };

  buttons.forEach((button) => {
    button.addEventListener('click', () => {
      const selected = button.dataset.fdoWineFilter;

      buttons.forEach((candidate) => {
        candidate.setAttribute('aria-pressed', String(candidate === button));
      });

      applyFilters(selected);
    });
  });

  const initialButton = buttons.find((button) => button.dataset.fdoWineFilter === requestedColour) || buttons[0];
  if (initialButton) {
    buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === initialButton)));
    applyFilters(initialButton.dataset.fdoWineFilter);
  }

  if (context && contextLabel && contextActive) {
    const pairingLabels = {
      aperitif: catalogue.dataset.pairingAperitifLabel,
      viande: catalogue.dataset.pairingViandeLabel,
      poisson: catalogue.dataset.pairingPoissonLabel,
      fromage: catalogue.dataset.pairingFromageLabel,
    };
    context.hidden = false;
    contextLabel.textContent = requestedAvailability === 'prochainement'
      ? catalogue.dataset.comingFilterLabel
      : `${catalogue.dataset.pairingPrefix} ${pairingLabels[requestedPairing] || requestedPairing.replace(/-/g, ' ')}`;
    if (contextHelp) {
      contextHelp.textContent = isComingContext
        ? catalogue.dataset.comingSelectionHelp
        : catalogue.dataset.selectionHelp;
      contextHelp.hidden = !contextHelp.textContent;
    }
    if (isComingContext) {
      if (recommendedHeading) recommendedHeading.textContent = catalogue.dataset.comingFilterLabel;
      if (otherHeading) otherHeading.textContent = catalogue.dataset.comingOtherHeading;
    }
  }
});


/*
 * Filet de fin de remise.
 *
 * Le gabarit ne barre un prix que si la remise est en cours, mais le cache de
 * Shopify peut servir une page rendue avant l'heure de fin. Chaque prix remisé
 * porte donc sa fin (data-fdo-fin, secondes Unix) et une version au prix plein
 * (data-fdo-etat="apres"). Passé la fin, la page bascule d'elle-même; ouverte
 * au moment de la fin, elle bascule à la seconde.
 */
(function () {
  function basculer() {
    var maintenant = Date.now() / 1000;
    var prochaine = Infinity;
    document.querySelectorAll('[data-fdo-fin]').forEach(function (el) {
      var fin = parseInt(el.getAttribute('data-fdo-fin'), 10);
      if (!fin) return;
      var fini = maintenant >= fin;
      if (!fini && fin < prochaine) prochaine = fin;
      el.hidden = el.getAttribute('data-fdo-etat') === 'apres' ? !fini : fini;
    });
    var attente = (prochaine - maintenant) * 1000;
    if (attente > 0 && attente < 86400000) setTimeout(basculer, attente + 500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', basculer);
  } else {
    basculer();
  }
})();
